import {store} from '../../App';
import config from '../../config';

import * as Artwork from './artwork';

let axios = require('axios'),
    io    = require('../io/index').actions,
    i18n  = require('i18next');

export const actiontypes = {
  TRACK_UPDATE_SUCCESS: 'TRACK_UPDATE_SUCCESS',
}
export const actions = {
  updateTrack: (track) => {
    return dispatch => {
      dispatch(io.loading());
      let messages = i18n.t('io', {returnObjects: true}).tracks.track.update;

      axios.put(`${config.API_ADDRESS}/track/${track._id}`,
        track
      , {
        headers: {
          'Authorization': `Bearer ${store.getState().session.token}`
        }
      })
      .then(res => res.data)
      .then(json => {
        dispatch(trackUpdateSuccess(json));
        dispatch(io.message(messages.success,'success', false));

        if (track._image) {
          dispatch(Artwork.actions.uploadTrackArtwork(json, track._image));
        } else if (track._removeImage) {
          dispatch(Artwork.actions.deleteTrackArtwork(json));
        }

      })
      .catch(err => dispatch(io.message(`${messages.error} (${err.message})`, 'error', false)));
    }
  }
}



function trackUpdateSuccess(track) {
  return {
    type: actiontypes.TRACK_UPDATE_SUCCESS,
    track
  }
}



// WEBPACK FOOTER //
// ./src/actions/tracks/update.js